// STYLES
import './_footer.scss'

// LIBS
import React from 'react'

// INTERFACE
const Footer = () =>
  <footer id="footer">
    <div className="container">
      <div className="row">
        <div className="col-md-3 detail-cell hq-social-details">
          <h5>Connect With Us</h5>
          <ul className="hq-social-list">
            <li><a target="_blank" href="https://www.facebook.com/codefellows.org">Facebook</a></li>
            <li><a target="_blank" href="https://twitter.com/CodeFellows">Twitter</a></li>
            <li><a target="_blank" href="https://www.linkedin.com/company/code-fellows">LinkedIn</a></li>
            <li><a href="/meet-the-team/">Meet the Team</a></li>
          </ul>
        </div>
        <div className="col-md-3 detail-cell hq-information-details">
          <h5>Learn More</h5>
          <ul className="hq-social-list">
            <li><a href="/faq/">FAQ</a></li>
              <li><a href="https://www.washingtontechnology.org/code-fellows/">Scholarship Fund Donations</a></li>
            <li><a href="/press/">Press</a></li>
            <li><a href="/about/">Our Story</a></li>
            <li><a href="/locations/learn-to-code-in-seattle/">Our Campus</a></li>
            <li><a href="/jobs-at-code-fellows/">Careers</a></li>
            <li><a href="/privacy-policy/">Privacy Policy</a></li>
          </ul>
        </div>
        <div className="col-md-3 detail-cell hq-contact-details">
          <h5>Take a Tour</h5>
          <ul className="hq-social-list">
            <li><a href="https://www.eventbrite.com/e/code-fellows-campus-tours-tickets-30180965079?aff=websitefooter" target="_blank">Thursdays<br/>
            12:00 - 12:30<br/>
            RSVP »</a></li>
          </ul>
          <br />
        </div>
        <div className="col-md-3 detail-cell hq-contact-details">
          <h5>Get in Touch</h5>
          <ul className="hq-social-list">
            <li><a href="https://learn.codefellows.org/apply-now?utm_source=footer&utm_medium=website&utm_campaign=coding-for-beginners">Apply Now</a></li>
            <li><a href="https://learn.codefellows.org/contact?utm_source=footer&utm_medium=website&utm_campaign=coding-for-beginners">Contact Us</a></li>
            <li><a href="tel:2066819318">
              206-681-9318
            </a></li>
          </ul>
          <address className="hq-address">
            <a
              target="_blank"
              href="https://www.google.com/maps?newwindow=1&biw=1265&bih=786&q=2901+3rd+Ave,+Suite+300+seattle+wa&bav=on.2,or.r_cp.&bvm=bv.117218890,d.cGc&um=1&ie=UTF-8&sa=X&ved=0ahUKEwjM5fvJ4sjLAhVE0WMKHbtCAqAQ_AUIBigB"
            >
              2901 3rd Ave. Suite 300 <br />
              Seattle, WA 98121 <br />
            </a>
          </address>
        </div>
      </div>
      <br />
      <div className="social-buttons">
        <a href="https://www.facebook.com/codefellows.org" target="_blank"><span className="fb-light"></span></a>
        <a href="https://twitter.com/codefellows" target="_blank"><span className="tw-light"></span></a>
        <a href="https://www.instagram.com/codefellows/" target="_blank"><span className="ig-light"></span></a>
        <a href="https://www.linkedin.com/school/2877757" target="_blank">  <span className="li-light"></span></a>
      </div>
      <p className="copyright">
        &copy;&nbsp;{new Date().getFullYear()}&nbsp;Code Fellows, Inc.
        Code Fellows is a licensed Technical Education provider by the state of Washington.
      </p>
    </div>
  </footer>

export default Footer



// WEBPACK FOOTER //
// ./src/components/footer/index.js